export const EASE = [0.16, 1, 0.3, 1];

export const scrollToSection = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -70, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
